import { useMutation, useQueryClient } from "@tanstack/react-query";
import { showErrorAlert } from "../../utils/showErrorAlert";
import { showSuccessToast } from "../../utils/showToastAlert";

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {(path: string) => void} deps.navigate
 * @param {(key: string) => string} deps.t
 */
export function usePostPolicy({ callApiWithWorker, t }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["createPolicy"],
    mutationFn: async (payload) => {
      return callApiWithWorker(`/policy-templates`, {
        method: "POST",
        body: payload,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["policies"] });

      showSuccessToast(t("createdSubMessage", "Creation successfully"), {
        title: t("createdMessage", "Política creada"),
      });
    },
    onError: (error) => {
      console.error("Error al crear la política:", error);
      showErrorAlert(error);
    },
  });
}
